import { connect } from "react-redux";
import get from "lodash/get";

import {
  getControlPoints as onGetControlPoints,
  createControlPoint as onCreateControlPoint,
  deleteControlPoint as onDeleteControlPoint,
  selectControlPoint as onSelectControlPoint,
  unselectControlPoint as onUnselectControlPoint,
  updateControlPoint as onUpdateControlPoint,
} from "./../../actions/controlPointActions";

const mapStateToProps = (state) => ({
  logisticControlPointsDataState: state.logisticControlPoints.logisticControlPointsDataState,
  logisticControlCreatePointsDataState: state.logisticControlPoints.logisticControlCreatePointsDataState,
  logisticControlDeletePointsDataState: state.logisticControlPoints.logisticControlDeletePointsDataState,
  logisticControlUpdatePointsDataState: state.logisticControlPoints.logisticControlUpdatePointsDataState,
  logisticControlPoints: get(state, ["logisticControlPoints", "logisticControlPoints"], []),
  logisticControlPointsGroups: get(state, ["logisticControlPoints", "logisticControlPointsGroups"], []),
  logisticSelectedControlPoint: get(state, ["logisticControlPoints", "logisticSelectedControlPoint"], null),
  logisticLastControlPoint: get(state, ["logisticControlPoints", "logisticLastControlPoint"], null),
});

const mapDispatchToProps = {
  onGetControlPoints,
  onCreateControlPoint,
  onDeleteControlPoint,
  onSelectControlPoint,
  onUnselectControlPoint,
  onUpdateControlPoint,
};

const withLogisticControlPoints = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withLogisticControlPoints };
